import LeftSidebar from "./LeftSidebar";
import React, { useState, useEffect } from "react";
import Topbar from "./Topbar";
import Footer from "./Footer";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { BASE_URL } from "../Config";
import { MDBDataTable } from "mdbreact";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";

const NewMembers = () => {
  const sendPaymentLink = async (id) => {
    if (!window.confirm("Send payment link to this member?")) return;

    try {
      const res = await axios.post(
        `${BASE_URL}/api/members/${id}/send-payment-link`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.success) {
        alert(
          "✅ Payment link sent! Razorpay will notify member via SMS/Email."
        );
      } else {
        alert("❌ Failed to send payment link.");
      }
    } catch (err) {
      console.error("Error sending payment link:", err);
      alert("Error sending payment link");
    }
  };

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const token = localStorage.getItem("token");

  // View modal
  const [showModal, setShowModal] = useState(false);
  const [details, setDetails] = useState(null);
  const [customerLoading, setCustomerLoading] = useState(false);

  // Import modal
  const [showImport, setShowImport] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importStatus, setImportStatus] = useState("");
  const [importBusy, setImportBusy] = useState(false);
  const [importErrors, setImportErrors] = useState([]);
  const [failedRows, setFailedRows] = useState([]);
  const [counts, setCounts] = useState({ inserted: 0, updated: 0 });
const [paymentModalShow, setPaymentModalShow] = useState(false);
const [paymentMemberId, setPaymentMemberId] = useState(null);
const [paymentCurrent, setPaymentCurrent] = useState('');
const [paymentDate, setPaymentDate] = useState('');
const [paymentAmount, setPaymentAmount] = useState('');
const [paymentBusy, setPaymentBusy] = useState(false);
const openPaymentModal = (e, memberId, currentStatus) => {
  if (e && e.preventDefault) e.preventDefault();
  setPaymentMemberId(memberId);
  setPaymentCurrent(currentStatus);
  setPaymentModalShow(true);
};
const closePaymentModal = () => {
  if (!paymentBusy) {
    setPaymentModalShow(false);
    setPaymentMemberId(null);
    setPaymentCurrent('');
  }
};

const updatePaymentStatus = async ( selectedStatus, selectedDate, selectedAmount) => {
  if (!paymentMemberId) return;
  try {
    setPaymentBusy(true);

    // normalize
    const nextStatus = selectedStatus;
   
    const nextDate = selectedDate;
    const nextAmount = selectedAmount;

    // OPTIONAL: if your backend expects integers instead of strings, map here:
    // const payloadStatus = (nextStatus === 'paid') ? 1 : (nextStatus === 'pending' ? 0 : null);

    await axios.patch(
      `${BASE_URL}/api/members/${paymentMemberId}/payment-status`,
      {  payment_status: nextStatus, payment_date: nextDate, payment_amount: nextAmount },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    // refresh and reset
    await fetchMembers();
    setPaymentModalShow(false);
    setPaymentMemberId(null);
    setPaymentCurrent('');
    alert('✅ Payment status updated successfully');
  } catch (err) {
    console.error('Failed to update payment status', err);
    alert('Failed to update payment status');
    
  } finally {
    setPaymentBusy(false);
  }
};

  const handleCloseModal = () => setShowModal(false);

  const handleView = (customerId) => {
    setShowModal(true);
    setCustomerLoading(true);
    axios
      .get(`${BASE_URL}/api/member/${customerId}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        setDetails(response.data.list || response.data);
        setCustomerLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching member details:", error);
        setCustomerLoading(false);
      });
  };

  const [tableData, setTableData] = useState({
    columns: [
      { label: "Sr.No.", field: "serial", sort: "asc" },

      { label: "Membership No.", field: "membership_no", sort: "asc" },
      { label: "Firm Name", field: "name", sort: "asc" },
      { label: "Email", field: "email", sort: "asc" },
      { label: "Firm Mobile No", field: "mobile", sort: "asc" },
      { label: "Payment Link", field: "payment_link", sort: "asc" },
      { label: "Manage Payment Status", field: "paymentStatus", sort: "asc" },
      { label: "Membership", field: "membership", sort: "asc" },
      { label: "Action", field: "action", sort: "asc" },
    ],
    rows: [],
  });

  const fetchMembers = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/newmembers`);
      const list = response.data.list || [];

      const rowsWithSerial = list.map((row, index) => {
        const statusColor =
          row.payment_status === "pending"
            ? "#f59e0b"
            : row.payment_status === "paid"
            ? "#10b981"
            : "#6b7280";

        return {
          serial: index + 1,

          membership_no:
            row.membership == null ? "Not Available" : row.membership,
          name: row.name,
          mobile: row.mobile,
          email: row.email,
          payment_link: (
            <>
            {row.payment_status === "pending" ? (
              <Button
                className="btn btn-primary"
                onClick={() => sendPaymentLink(row.id)}
              >
                <i className="fa fa-credit-card"></i> Send Now
              </Button>
          
             ) : (
              ''
            )}</>
          ),
          // Clickable status badge
          paymentStatus:
            row.payment_status === "pending" ? (
            
                <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#ffb300ff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block',
                textDecoration: 'none'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status.toUpperCase()}</a>
              
            ) : row.payment_status === "paid" ? (
             
                <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#058442ff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status.toUpperCase()}</a>
              
            ) : (
            
                <a style={{
                cursor: 'pointer',
                color: '#fff',
                backgroundColor: '#f90d0dff',
                padding: '4px 10px',
                borderRadius: '12px',
                fontSize: '12px',
                display: 'inline-block'
              }} href="#" onClick={(e) => openPaymentModal(e, row.id, row.payment_status)}>{row.payment_status} </a>
            ),
            membership:(
              <>
            {row.payment_status === "paid" ? (
              <Button
                style={{
                  color: "#fff",
                  backgroundColor: '#10b981',
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  display: "inline-block",}}
                onClick={() => generateMembership(row.id)}
              >
                 Generate
              </Button>
          
            ) : row.payment_status === "done" ? (
              <span style={{
                  color: "#fff",
                  backgroundColor: '#f58026ff',
                  padding: "4px 10px",
                  borderRadius: "12px",
                  fontSize: "12px",
                  display: "inline-block",}}>Processed</span>
                ) : (''
            )}</>
            ),

          // Actions including Delete
          action: (
            <>
              <Link to={`/new-member-view/${row.id}`} title="View">
                <i className="fa fa-eye"></i>
              </Link>{" "}
              &nbsp;
              <Link to={`/new-member-edit/${row.id}`} title="Edit">
                <i className="fa fa-pencil-square-o"></i>
              </Link>{" "}
              &nbsp;
              <span
                title="Delete"
                style={{ cursor: "pointer", color: "#dc3545" }}
                onClick={() => confirmDelete(row.id)}
              >
                <i className="fa fa-trash"></i>
              </span>
            </>
          ),
        };
      });

      setTableData((prevData) => ({ ...prevData, rows: rowsWithSerial }));
    } catch (error) {
      console.error("Error fetching members:", error);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  // Toggle status handler

  // Delete flow
  const confirmDelete = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this member? This action cannot be undone."
      )
    ) {
      deleteMember(id);
    }
  };

  const deleteMember = async (id) => {
    try {
      await axios.delete(`${BASE_URL}/api/members/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      await fetchMembers();
    } catch (e) {
      console.error("Failed to delete member", e);
      alert("Failed to delete member");
    }
  };
const generateMembership = async (id) => {
  try {
    const response = await axios.get(`${BASE_URL}/api/membership/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });

    // Optional: check for expected response
    if (response.status === 200) {
      await fetchMembers();
      alert("✅ Membership No. generated successfully");
    } else {
      alert("⚠️ Unexpected response from the server.");
    }
  } catch (e) {
    console.error("❌ Failed to generate membership", e);
    alert("❌ Failed to generate membership");
  }
};

  // Import handlers
  const openImport = () => {
    setShowImport(true);
    setImportFile(null);
    setImportStatus("");
    setImportBusy(false);
    setImportErrors([]);
    setFailedRows([]);
    setCounts({ inserted: 0, updated: 0 });
  };

  const closeImport = () => setShowImport(false);

  const onFileChange = (e) => {
    const f = e.target.files?.[0] || null;
    if (f && !/\.(csv|xlsx)$/i.test(f.name)) {
      setImportStatus(
        "Only .csv or .xlsx files are supported. Please convert .xls to .csv or .xlsx."
      );
      setImportFile(null);
      return;
    }
    setImportFile(f);
    setImportStatus("");
    setImportErrors([]);
    setFailedRows([]);
    setCounts({ inserted: 0, updated: 0 });
  };

  const handleImport = async (e) => {
    e.preventDefault();
    if (!importFile) {
      setImportStatus("Please choose a file (.csv or .xlsx).");
      return;
    }

    const formData = new FormData();
    formData.append("file", importFile);

    try {
      setImportBusy(true);
      setImportStatus("Uploading and importing...");
      setImportErrors([]);
      setFailedRows([]);
      setCounts({ inserted: 0, updated: 0 });

      const res = await axios.post(
        `${BASE_URL}/api/import/newmembers`,
        formData,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      const data = res.data;
      setImportStatus(data.message || "Import completed.");
      setCounts({ inserted: data.inserted || 0, updated: data.updated || 0 });
      setFailedRows(data.failed_rows || []);

      fetchMembers();
    } catch (err) {
      if (err.response) {
        const data = err.response.data || {};
        setImportStatus(`Error: ${data.message || "Import failed"}`);
        if (data.errors) {
          const flat = Object.values(data.errors).flat();
          setImportErrors(flat);
        } else if (data.error) {
          setImportErrors([data.error]);
        } else {
          setImportErrors(["Unknown error occurred."]);
        }
      } else {
        setImportStatus("Network error.");
        setImportErrors([err.message]);
      }
    } finally {
      setImportBusy(false);
    }
  };

  const downloadTemplate = () => {
    const headers = [
      "membership,name,mobile,mobile_alt,address,area,rep_name_1,rep_mobile_1,rep_name_2,rep_mobile_2,rep_name_3,rep_mobile_3,rep_name_4,rep_mobile_4,rep_name_5,rep_mobile_5",
    ];
    const example = [
      'Gold,Acme Corp,9876543210,9876500000,"12, MG Road",Pune,John,9988776655,Ana,9988776656,Bob,9988776657,Cat,9988776658,Dan,9988776659',
      "Silver,Beta LLC,9123456789,,Plot 10,Mumbai,,,,,,,,,,",
    ];
    const csv = [headers.join(","), ...example].join("\n");
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "members_template.csv";
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {/* View Modal */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Member Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {customerLoading ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner animation="grow" size="sm" variant="primary" />
              <Spinner animation="grow" size="sm" variant="primary" />
              <Spinner animation="grow" size="sm" variant="primary" />
            </div>
          ) : details ? (
            <div>
              <p className="text-black">
                <strong>Customer Name:</strong> {details.name}
              </p>
              <p className="text-black">
                <strong>Email:</strong> {details.email}
              </p>
              <p className="text-black">
                <strong>Mobile No.:</strong> {details.mobile}
              </p>
              <p className="text-black">
                <strong>Address:</strong> {details.billing_address}
              </p>
            </div>
          ) : (
            <p>No customer details available</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={paymentModalShow} onHide={closePaymentModal} centered>
  <Modal.Header closeButton>
    <Modal.Title>Change Payment Status</Modal.Title>
  </Modal.Header>

  <Modal.Body>
     

    <select
      value={paymentCurrent}
      onChange={(e) => setPaymentCurrent(e.target.value)}
      className="form-select mb-3"
    >
      <option value="paid">Paid</option>
      <option value="pending">Pending</option>
      <option value="NA">NA</option>
    </select>
    <input
      type="date"
      className="form-control mb-3"
      value={paymentDate}
      onChange={(e) => setPaymentDate(e.target.value)}
    />
    <input
      type="number"
      className="form-control mb-3"
      placeholder="Enter Payment Amount"
      value={paymentAmount}
      onChange={(e) => setPaymentAmount(e.target.value)}
    />  

    <p>Choose a payment mode, payment status, date, amount, and click <strong>Update</strong>.</p>
  </Modal.Body>

  <Modal.Footer>
    <Button variant="secondary" onClick={closePaymentModal} disabled={paymentBusy}>
      Cancel
    </Button>

    <Button
      variant="primary"
      onClick={() => updatePaymentStatus( paymentCurrent, paymentDate, paymentAmount)}
      disabled={paymentBusy || !paymentMemberId}
    >
      {paymentBusy ? 'Saving...' : 'Update'}
    </Button>
  </Modal.Footer>
</Modal>

      {/* Import Modal */}
      <Modal show={showImport} onHide={closeImport}>
        <Modal.Header closeButton>
          <Modal.Title>Import Members</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ marginBottom: 8 }}>
            <Button
              size="sm"
              variant="outline-secondary"
              onClick={downloadTemplate}
            >
              Download CSV Template
            </Button>
          </div>
          <form onSubmit={handleImport}>
            <input
              type="file"
              accept=".csv,.xlsx"
              onChange={onFileChange}
              disabled={importBusy}
            />
            <div style={{ marginTop: 12 }}>
              <Button type="submit" disabled={importBusy || !importFile}>
                {importBusy ? "Importing..." : "Start Import"}
              </Button>
            </div>
          </form>
          {importStatus && <p style={{ marginTop: 12 }}>{importStatus}</p>}
          {(counts.inserted > 0 || counts.updated > 0) && (
            <p>
              Inserted: {counts.inserted} | Updated: {counts.updated}
            </p>
          )}
          {importErrors.length > 0 && (
            <div style={{ color: "crimson", marginTop: 12 }}>
              <strong>Errors:</strong>
              <ul>
                {importErrors.map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
              </ul>
            </div>
          )}
          {failedRows.length > 0 && (
            <div style={{ marginTop: 12 }}>
              <strong>Row validation failures:</strong>
              <ul style={{ maxHeight: 200, overflowY: "auto" }}>
                {failedRows.map((f, i) => (
                  <li key={i}>
                    Row {f.row}:{" "}
                    {Array.isArray(f.errors)
                      ? f.errors.join("; ")
                      : String(f.errors)}{" "}
                    | Values: {JSON.stringify(f.values)}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={closeImport}
            disabled={importBusy}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <div id="page-top">
          <div id="wrapper">
            <LeftSidebar
              isSidebarOpen={isSidebarOpen}
              toggleSidebar={toggleSidebar}
            />
            <div id="content-wrapper" className="d-flex flex-column">
              <div id="content">
                <Topbar
                  isSidebarOpen={isSidebarOpen}
                  toggleSidebar={toggleSidebar}
                />
                <div className="container-fluid">
                  <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">Members</h4>
                    <Button variant="primary" onClick={openImport}>
                      <i className="fa fa-upload" /> Import
                    </Button>
                  </div>

                  <MDBDataTable striped bordered small data={tableData} />
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>
        <a className="scroll-to-top rounded" href="#page-top">
          <i className="fas fa-angle-up"></i>
        </a>
      </div>
    </>
  );
};

export default NewMembers;
